import { render, staticRenderFns } from "./PaymentNotificationBadge.vue?vue&type=template&id=53220aba&scoped=true"
import script from "./PaymentNotificationBadge.vue?vue&type=script&lang=js"
export * from "./PaymentNotificationBadge.vue?vue&type=script&lang=js"
import style0 from "./PaymentNotificationBadge.vue?vue&type=style&index=0&id=53220aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53220aba",
  null
  
)

export default component.exports